import { idSchema } from "@my-saas/schema";
import { dateSchema } from "@my-saas/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const tenantSlugSchema = z
  .string()
  .min(2, "Slug must be at least 2 characters")
  .max(63, "Slug must be at most 63 characters")
  .regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/, {
    message: "Slug must be lowercase alphanumeric with hyphens (e.g. 'kafri-emergency')",
  });

export const tenantSchema = z.object({
  id: idSchema,
  slug: tenantSlugSchema,
  name: z.string().min(1).max(255),
  status: z.enum(["ONBOARDING", "ACTIVE", "SUSPENDED"]).default("ONBOARDING"),
  logoPath: z.string().default(""),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class TenantDto extends createZodDto(tenantSchema) {}

export const createTenantSchema = z.object({
  name: z.string().min(1).max(255),
  // slug is optional — frozen=id per plan; if provided we use it as the public-facing slug
  slug: tenantSlugSchema.optional(),
});

export class CreateTenantDto extends createZodDto(createTenantSchema) {}
